/**
 * Karten-Winraten-API - liest echte, gezaehlte Wild-Sieg-/Einsatzquoten aus
 * /root/bot's eigener Kampfdatenbank, ueber den Marktplatz-Backend-Endpunkt
 * (market/views.py:get_card_winrates, market/urls.py).
 *
 * Anders als botApi.js/snipeApi.js kein Dev-only-Proxy: dieser Endpunkt lebt im
 * regulaeren, produktiven Marktplatz-Backend (elmo-burns/backend), gleiche
 * Basis-URL wie MarketService.js.
 */
import { API_BASE_URL } from './api';

export async function fetchCardWinrates({ league = 'champion', minPlays = 100, limit = 200, username }) {
  if (!username) {
    throw new Error('username is required');
  }
  const params = new URLSearchParams({
    league, min_plays: String(minPlays), limit: String(limit), username,
  });
  const response = await fetch(`${API_BASE_URL}/v1/market/card-winrates/?${params.toString()}`);
  let payload = null;
  try {
    payload = await response.json();
  } catch (e) {
    // keine JSON-Antwort - unten als HTTP-Fehler behandelt
  }
  if (!response.ok) {
    throw new Error(payload?.error || `HTTP ${response.status}`);
  }
  return payload;
}
